/* External dependencies */
import { encode } from 'base64-arraybuffer';

export function convertArrayBufferToBase64(buffer: ArrayBuffer): string {
  return encode(buffer);
}
